export default [
    { id: 'email', value: 'email only' },
    { id: 'email_sms', value: 'email/sms' },
];
